/* eslint-disable react/jsx-props-no-spreading */
import { Route, Redirect } from 'react-router-dom';

const PublicRoute = ({ component: Component, restricted, ...rest }) => (
  <Route
    {...rest}
    render={(props) => (
      restricted
        ? <Redirect to="/" />
        : <Component {...props} />
    )}
  />
);
export default PublicRoute;
